<template>
<div class="Yinshiyun">
    <iframe ref="video_player" :src="baseUrl+'yingshi-iframe.html'"></iframe>
</div>
</template>

<script>
import circleButton from './circle_button.vue'
export default {
    props: {
        data: {
            type: Object,
            default: function () {
                return {};
            }
        },
        baseUrl: {
            type: String,
            default: process.env.BASE_URL
        }
    },
    components:{
        circleButton
    },
    mounted() {
        this.$nextTick(() => {
            this.page_init();
            console.log(this.data);
        })
    },
    methods: {
        page_init() {
            if (this.$refs.video_player) {
                this.$refs.video_player['setAttribute']('width', this.$el.clientWidth + 'px');
                this.$refs.video_player['setAttribute']('height', this.$el.clientHeight + 'px');
                this.iframe_onload();
            }
        },
        iframe_onload() {
            this.$refs.video_player['contentWindow'].onload = () => {
                this.$refs.video_player['contentWindow'].video_init(this.data, this);
            }
        },
      
    }
}
</script>

<style lang="less" scoped>
@import url("../../assets/less-css/flexible.less");

.Yinshiyun {
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    width: 100%;
    .h(455);
    iframe {
        display: block;
        border: none;
    }
}
</style>
